/** @format */

import {
	ATC_BUTTON_TEXTS,
	FulfillmentButtonInterface,
	selectAtcFulfillmentOption,
	selectInStorePickupButtonText,
	selectProductSelectionState,
	selectSameDayDeliveryButtonText,
	selectShipToMeButtonText
} from '@pdp/add-to-cart/data-access';
import {
	selectAllProductStyle,
	selectcustomProductData,
	selectResolvedSku,
	selectSelectedPersonalizationOptions
} from '@pdp/data-access/state';

import { ProductSku } from '@shared/data-access/interfaces';
import { createSelector } from '@ngrx/store';
import { selectUserZipCode } from '@state/data-access';

/**
 * @description Add to Cart Button
 * Handles each different product scenario for the add to cart button
 * Currently add to cart button is used below fulfillment buttons and this will select
 * the text and enabled/disabled state for the button
 */

export const selectAddToCartButtonText = createSelector(
	selectAtcFulfillmentOption,
	selectShipToMeButtonText,
	selectInStorePickupButtonText,
	selectSameDayDeliveryButtonText,
	selectAllProductStyle,
	selectcustomProductData,
	selectSelectedPersonalizationOptions,
	(
		shipMode,
		shipToMeText,
		InStorePickupText,
		sameDayDeliveryText,
		productStyle,
		customProductData,
		selectedPersonalizationOptions
	) => {
		if (productStyle.isCustomizable && !customProductData) {
			return {
				addToCartButtonText: ATC_BUTTON_TEXTS.customize,
				addToCartButtonDisabled: false
			};
		} else if (productStyle.isPersonalizable && !selectedPersonalizationOptions.valid) {
			return {
				addToCartButtonText: ATC_BUTTON_TEXTS.atc,
				addToCartButtonDisabled: false,
				buttonAction: 'SelectOptions'
			};
		} else if (shipMode === 'shipToMe') {
			return shipToMeText;
		} else if (shipMode === 'sameDayDelivery') {
			return sameDayDeliveryText;
		} else {
			return InStorePickupText;
		}
	}
);

export const selectAddToCartButtonTextSDDynamicEnabled = createSelector(
	selectAddToCartButtonText,
	selectAtcFulfillmentOption,
	selectUserZipCode,
	selectResolvedSku,
	(
		addToCartButtonText: FulfillmentButtonInterface,
		shipMode: string,
		userZipCode: string,
		resolvedSku: ProductSku
	) => {
		if (
			shipMode === 'sameDayDelivery' &&
			(userZipCode === 'null' || !userZipCode) &&
			resolvedSku !== null
		) {
			addToCartButtonText.addToCartButtonText = ATC_BUTTON_TEXTS.enterZip;
			addToCartButtonText.addToCartButtonDisabled = false;
		}
		return addToCartButtonText;
	}
);

export const selectIsProductAvailable = createSelector(
	selectAddToCartButtonText,
	(addToCartButtonText: FulfillmentButtonInterface) => {
		const isAvailable =
			!addToCartButtonText?.addToCartButtonDisabled &&
			addToCartButtonText.addToCartButtonText !== ATC_BUTTON_TEXTS.notifyMe;
		const isSkuResolved = addToCartButtonText.buttonAction !== 'SelectOptions';
		return { isAvailable, isSkuResolved };
	}
);

export const selectAddToCart = createSelector(
	selectProductSelectionState,
	(state) => state.addToCart
);

export const selectUserInputQty = createSelector(
	selectAddToCart,
	(state) => state.userInputQuantity
);
